import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ProviderService } from '../../../provider.service';
import {
  IProvider,
  IProviderBase,
  PROVIDER_TTL_ES
} from '../../../provider.interface';
import { UpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.template';
import { IUpdateTemplate } from 'src/app/@amiga-pyme/crud/templates/update/update.interface';

@Component({
  selector: 'pg-provider-update',
  templateUrl: './provider-update.component.html'
})
export class ProviderUpdateComponent
  extends UpdateTemplate
  implements IUpdateTemplate
{
  constructor(private fb: FormBuilder, private serviceBase: ProviderService) {
    super(PROVIDER_TTL_ES, serviceBase);
  }

  ngOnInit() {
    const item = this.row as IProvider;
    this.fg = this.fb.group({
      ruc: [
        item.ruc,
        [
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.pattern('\\d+')
        ]
      ],
      name: [
        item.name,
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      address: [
        item.address,
        [
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      email: [item.email, [Validators.email]],
      mobile: [
        item.mobile,
        [
          Validators.minLength(9),
          Validators.maxLength(9),
          Validators.pattern('\\d+')
        ]
      ]
    });
  }

  onSubmit() {
    const provider = this.parseDate();
    this.updateItem$(provider);
  }

  private parseDate() {
    const provider = this.fg.value as IProviderBase;
    if (provider.address == null || provider.address == '') delete provider.address;
    if (provider.email == null || provider.email == '') delete provider.email;
    if (provider.mobile == null || provider.mobile == '') delete provider.mobile;
    return provider;
  }
}
